module.exports = __webpack_public_path__ + "assets/send.7549c76f.svg";